import { useQuery } from 'data-fetching-client';
import { INSTALL_STATS_QUERY } from 'marketplace-ui-common/offerings/queries/installStatsQuery';
export default function useInstallStats({
  offeringId,
  skip
}) {
  const {
    data: installStatsData,
    loading: installStatsLoading,
    error: installStatsError
  } = useQuery(INSTALL_STATS_QUERY, {
    skip: skip || !offeringId,
    variables: {
      offeringId: String(offeringId)
    }
  });
  return {
    installStatsData,
    installStatsLoading,
    installStatsError
  };
}